<div id="scroll-indicator"></div>
<nav class="navbar navbar-expand-lg fixed-top nav-down" color-on-scroll="500">
    <div class="container" style="max-width: 1240px;">
        <!-- <div class="container"> -->
        <div class="navbar-translate">
            <div class="navbar-header">
                <a class="icon icon-shape mt-2 mb-2" [routerLink]="['/presentation']">

                    <img class="mt-2 mb-2" alt="" src="./assets/img/logo_130_square.png" style="height: 65px;">

                </a>
            </div>
            <button class="navbar-toggler navbar-burger" type="button" data-toggle="collapse"
                data-target="#navbarToggler" aria-controls="navbarTogglerDemo02" aria-expanded="false"
                aria-label="Toggle navigation" (click)="sidebarToggle()">
                <span class="navbar-toggler-bar bar1"></span>
                <span class="navbar-toggler-bar bar2"></span>
                <span class="navbar-toggler-bar bar3"></span>
            </button>
        </div>
        <div class="collapse navbar-collapse">
            <ul class="navbar-nav ml-lg-auto ml-n3">

                <li class="nav-item mt-2">
                    <a class="nav-link" href="" [routerLinkActive]="['active']" [routerLinkActive]="['active']">
                        Home
                    </a>
                </li>


                <div ngbDropdown class="nav-item dropdown mt-2">
                    <div class="nav-link dropdown-toggle" ngbDropdownToggle>Features</div>
                    <div ngbDropdownMenu class="dropdown-menu dropdown-menu-right dropdown-danger">
                        <a ngbDropdownItem href="features"><i class="nc-icon nc-simple-delete"></i>Overview</a>
                        <a ngbDropdownItem href="features/#ref_pms"><i
                                class="nc-icon nc-simple-delete text-wrap"></i>Practice
                            Management Software</a>
                        <a ngbDropdownItem href="features/#ref_cn"><i class="nc-icon nc-simple-delete"></i>Clinical
                            Notes</a>
                        <a ngbDropdownItem href="features/#ref_rtcp"><i class="nc-icon nc-simple-delete"></i>Real Time
                            Claims Processing</a>

                    </div>
                </div>


                <div ngbDropdown class="nav-item dropdown mt-2">
                    <div class="nav-link dropdown-toggle" ngbDropdownToggle>Packages</div>
                    <div ngbDropdownMenu class="dropdown-menu dropdown-menu-right dropdown-danger">
                        <a ngbDropdownItem href="/packages/diy-starter"><i class="nc-icon nc-simple-delete"></i>DIY
                            Starter</a>
                        <a ngbDropdownItem href="/packages/diy"><i class="nc-icon nc-simple-delete"></i>DIY</a>
                        <a ngbDropdownItem href="/packages/full-house"><i class="nc-icon nc-simple-delete"></i>Full
                            House</a>
                        <a ngbDropdownItem href="/packages/e-buro"><i class="nc-icon nc-simple-delete"></i>e-Buro</a>
                    </div>
                </div>



                <li class="nav-item mt-2">
                    <a class="nav-link" [routerLink]="['/contact_us']" [routerLinkActive]="['active']">
                        Contact Us
                    </a>
                </li>

                <li *ngIf="is_international==false" class="nav-item mt-2">
                    <a class="nav-link" [routerLink]="['/support']" [routerLinkActive]="['active']">
                        Support
                    </a>
                </li>


                <li class="nav-item">
                    <a class="nav-link d-flex align-items-center" [routerLink]="['/system_status']"
                        [routerLinkActive]="['active']">
                        <span>Online</span> <span class="status {{Data.status}} ml-2"></span>
                    </a>
                </li>




                <li *ngIf="is_international==false" class="nav-item mt-2">
                    <a class="btn btn-round bg-gradient-secondary" [routerLink]="['/login']">
                        Login
                    </a>
                </li>

                <li class="nav-item mt-2">
                    <a class="btn btn-round btn-danger" [routerLink]="['/get-a-quote']">
                        Get a quote
                    </a>
                </li>

                <li class="nav-item">



                    <a href="https://www.doctorsnearme.co.za/index" class="nav-link" target="_blank">

                        <img class="mt-1" alt="" src="./assets/img/brand/dnm_nodrop.png">

                    </a>

                </li>






            </ul>
        </div>
    </div>
</nav>